<div class="d-flex align-items-center align-items-right" *ngIf="($progress | async); let progress">
    {{ progress }} <button mat-button mat-icon-button (click)="exit()"><mat-icon  >close</mat-icon></button>
</div>
